
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import * as FaIcons from "react-icons/fa";
import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import {useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';
import {roundToNthNearestMinute} from "../../utils/funcs.js"
import {PlotSectionDiv,EpochDataBlock} from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Checkbox from '@mui/material/Checkbox';


const DEG_TO_NM   = 60.0405
const NM_TO_DEG   = 1/DEG_TO_NM


const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

const TitleDiv = styled.div`
    min-width:85vw;
`;
const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
					'#FB0D0D','#DA16FF','#222A2A']
const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

// <TitleDiv>
            // <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
        // </TitleDiv>

const homePlotlyIcon = {
            width: 928.6,
            height: 1000,
            path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
            transform: 'matrix(1 0 0 -1 0 850)'
        }

const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];
const axesLineColor ='#FFFF'//'rgba(220,232,247,0.1)'
const axesLineWidth = 5
const countLevels = [5,15,30,60,120,720,1440,7200]
const countLevelLabels = {'5min':'5 min',
                              '15min': '15 min',
                              '30min':'30 min',
                              '60min':'1 hr',
                              '120min':'2 hr',
                              '720min':'12 hr',
                              '1440min':'1 day',
                              '7200min':'5 days'}
const turbCountSectors = ['North','Northeast','East','Southeast','South','Southwest','West','Nortwest']
const MAP_TIME_RANGE_VALUES = ['5min','1hr','24hr']

const FlightPlanChangeCounts = ({setTitle,pageTitle,metricLookBackHorizonDays,backendApiPrefix}) => {
    const {airport} = useParams()
    const [isChartLoading,setIsChartLoading] = useState(true)
    const [isMapLoading,setIsMapLoading] = useState(false)
    const [lastUpdatedTime,setLastUpdatedTime] = useState(new Date())
    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))
    const [airportMapTrace,setAirportMapTrace] = useState({type: "scattermapbox",
                                                           lat: [],
                                                           lon: [],
                                                           text:[],
                                                           textfont:{size:16,color:'black'},
                                                           textposition:'top right',
                                                           marker: {symbol:'marker',color: "black", size: 10,allowoverlap:true},
                                                           hoverinfo:'skip',
                                                           name:'',
                                                           mode:'markers+text',
                                                           hovertemplate:'<extra></extra>',
                                                           showlegend:false})

    const [conflictTracksTrace,setConflictTracksTrace] = useState({type: "scattermapbox",
                                                        lat: [],
                                                        lon: [],
                                                        text: [],
                                                        customdata:[],
                                                        marker: {color: "red", size: 5 },
                                                        opacity:0.3,
                                                        hovertemplate:'<extra></extra><b>Lat</b>:%{lat:.2f} <b>Lon</b>:%{lon:.2f} <b>Alt</b>:%{text:.0f}ft<br>'+
                                                                                    '<b>AC</b>: %{customdata[0]}, <b>Conflict AC</b>: %{customdata[1]}<br>'+
                                                                                    '<b>Conformance Cat.</b>: %{customdata[2]}<br>'+
                                                                                    '<b>Airspace Class</b>: %{customdata[3]}',
                                                        hoverlabel:{bgcolor:'white'},
                                                        showlegend:false})
    

    const [countLevelChecked,setCountLevelChecked] = useState(countLevels.reduce((acc,key)=>{acc[key]=(key===5||key===15)?true:false;return acc},{}))
    const [mapData,setMapData] = useState({'5min':{},'1hr':{},'24hr':{}})
    const [mapTimeRange,setMapTimeRange] = useState(MAP_TIME_RANGE_VALUES[0])
    const [highlightYMarker,setHighlightYMarker] = useState({'index':1})
    const [mapPlotTraces,setMapPlotTraces] = useState([])
    useEffect(() => {
        setTitle(pageTitle=>'Flight Plan Change Counts - '+airport)
    },[airport]);
    // {

    //     name: 'color toggler',
    
    //     icon: icon1,
    
    //     click: function(gd) {
    
    //         var newColor = colors[Math.floor(3 * Math.random())]
    
    //         Plotly.restyle(gd, 'line.color', newColor)
    
    //     }},
    const [airportData, setAirportData] = useState({'location':[],'city':''}); 
    const [latestEpochFlag,setLatestEpochFlag] = useState(true)
    const [selectedEpoch,setSelectedEpoch] = useState('')

    const [epochString,setEpochString] = useState([])
    const [flightPlanChangeCounts,setFlightPlanChangeCounts] = useState({})
    const [plotMapLayout, setPlotMapLayout] = useState({
        mapbox: 
        { 
            style: "light", 
            center:{lat:null,lon:null},
            bounds:{'north':null,
                     'east':null,
                    'south':null,
                     'west':null},
            zoom:7,
            accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
            domain:{'x':[0.01,1],'y':[0.01,0.99]}
        },
        margin:{l:10,t:10,r:12,b:10},
        xaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
        yaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
        showlegend:false,plot_bgcolor:'rgba(220,232,247,0.4)'
        },
        );

    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:3,columns:1,ygap:0.2},
            xaxis:{anchor:('y','y2'),
                zeroline:false,
                range:[epochString[0],epochString[epochString.length-1]],
                rangeselector:{
                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                                 {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                                 {count:1,label:'1d',step:'day',stepmode:'backward'},
                                 {step:'all'}]},
                type:'date',  		
                tickfont:{size:10},
                showticklabels:true,
                autorange:true,
                domain:[0,0.98],
                mirror:'all', showline:true,linecolor:axesLineColor,linewidth:axesLineWidth,nticks:7},
            yaxis:{anchor:'x',title:{text:'Flight Plan<br>Change Counts',size:10},zeroline:false,domain:[0.2,1],showticklabels:true,autorange:true,
                            showline:true,linecolor:axesLineColor,linewidth:axesLineWidth},
            legend:{x:1,xanchor:'left',y:1,yanchor:'top',bgcolor:'rgba(0,0,0,0)',orientation:'v',
                    bordercolor: '#D3D3D3',borderwidth: 2},
            annotations:[],
            margin:{t:54,r:10,b:10},
            height:300,
            hovermode:'x unified',
            plot_bgcolor:'rgba(220,232,247,0.4)'});

    
    const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
        'toggleSpikelines','select2d',
        'zoomIn2d','zoomOut2d','lasso2d',
        'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
        'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
        'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
        'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
        'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
        'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
         displaylogo:false,responsive:true})

    
    
    const [leftDivHeight, setLeftDivHeight] = useState(null);
    const [leftDivWidth, setLeftDivWidth] = useState(null);
    
    const [rightDivHeight, setRightDivHeight] = useState(null);
    const [rightDivWidth, setRightDivWidth] = useState(null);
    
    const [revKey, setRevKey] = useState(0);
    
    useEffect(() =>{
      setTimeout(()=>{
      setPlotChartLayout({...plotChartLayout,
                          width:0.98*leftDivWidth
                        });
      
      // setPlotMapLayout({...plotMapLayout,
                       // width:0.98*rightDivWidth,
                       // });
                       
      setPlotMapLayout({...plotMapLayout,
                           width:0.98*rightDivWidth,
                           mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    },
                            zoom:7});
                                    
      setAirportMapTrace({...airportMapTrace,
                        lat: [airportData['location'][0]],
                        lon: [airportData['location'][1]],
                        text:[airport],
                        name:airport,
                        hovertemplate:'<extra></extra>'+airport,
                        })
                       
      },20)
    },[leftDivWidth,rightDivWidth,airportData]);
    
    useEffect(() => {
        axios.post(backendApiPrefix+'/api/get-airport-data/',{airport:airport})
            .then(response => {
                var jsonData = response.data.message
                console.log(jsonData)
                setAirportData(jsonData)
             })
            .catch(error => {
                console.log(error);
            });
        setConflictTracksTrace({...conflictTracksTrace,
                lat:[],lon:[],text:[],customdata:[]})
    },[airport]);
    
    useEffect(()=>{
        var highestLevelChecked;
        for(var lvl of countLevels){
            if(!countLevelChecked[lvl]){
                continue;
            }
            highestLevelChecked = lvl
        };
        if(highestLevelChecked){
            var keyVal = highestLevelChecked+'min'
            if(Object.keys(flightPlanChangeCounts).includes(keyVal)){
                var updateYHighlightMarker = {'index':1.2*Math.max(...flightPlanChangeCounts[keyVal])}
                setHighlightYMarker(updateYHighlightMarker)
            }
        }
    },[selectedEpoch,countLevelChecked,flightPlanChangeCounts])

    useEffect(() => {
        const QUERY_CHUNK_HOURS = 6;
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS* 60*60*1000)
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
            axios.post(backendApiPrefix+'/api/get-flight-plan-change-counts-data/',{airport:airport,from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
                .then(response => {
                    var jsonData = response.data.message
                    setQueryIterTime(shiftedQueryIterTime)
                    setEpochString([...jsonData.epochString,...epochString])
                    
                    if(latestEpochFlag&&selectedEpoch===''){
                        if(epochString.length > 0){
                            setSelectedEpoch(epochString[epochString.length-1])
                        }else{
                            setSelectedEpoch(jsonData.epochString[jsonData.epochString.length-1])
                        }
                    }
                    var updateDataCounts = {}
                    for(var key of Object.keys(jsonData)){
                        if(Object.hasOwn(flightPlanChangeCounts,key)){
                            updateDataCounts[key] = [...jsonData[key],...flightPlanChangeCounts[key]]
                        }else{
                            updateDataCounts[key] = jsonData[key]
                        }
                    }
                    setFlightPlanChangeCounts({...flightPlanChangeCounts,...updateDataCounts})
                    
                                
                    setPlotChartLayout({...plotChartLayout,
                        nticks:Math.round(leftDivWidth/100)})
                    setIsChartLoading(false)
            })
                .catch(error => {
                    console.log(error);
                    setIsChartLoading(false)
                });
        }

    },[queryIterTime])      
    useEffect(() => {
                setPlotMapLayout({...plotMapLayout,
                                    mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    zoom:7}});
                                    
        setAirportMapTrace({...airportMapTrace,
                            lat: [airportData['location'][0]],
                            lon: [airportData['location'][1]],
                            text:[airport],
                            name:airport,
                            hovertemplate:'<extra></extra>'+airport,
                            })
    },[airportData])
    
    
    const mounted = useRef();
    useEffect(() => {
       if(mounted.current){
           // Component mounted
           console.log("Updated")
       } else {
            console.log("Mounted")
            mounted.current = true
            
       }
    });
    // const chartDiv = useCallback(node => {
        // if (node !== null) {
          // setLeftDivHeight(node.getBoundingClientRect().height);
          // setLeftDivWidth(node.getBoundingClientRect().width);
          // console.log("HEIGHT",height)
          // console.log("HEIGHT",width)
        // }
        // }, []);
    const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // This will be called on both refresh and page close
      setIsRefreshing(true);
      setRevKey(prevVal => prevVal +1)
      // The following is necessary for older browsers
      event.preventDefault();
      event.returnValue = '';
    };

    
    window.addEventListener('load', handleBeforeUnload);

    return () => {
      window.removeEventListener('load', handleBeforeUnload);
    };
  });

  useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
            setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyChartDiv"));
        
        
    });
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
            setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyMapDiv"));
    });
    const [menuOption, setMenuOption] = React.useState(1);

    const handleChange = (event: SelectChangeEvent) => {
        setMenuOption(String(event.target.value));
      };
    
    
    const handleLatestEpochButton = () =>{
        setLatestEpochFlag(true)
        setSelectedEpoch(epochString[epochString.length-1])
        updateMapData(epochString[epochString.length-1])
    }
    
    const handleDoubleClickOnMap=(data)=>{
        setPlotMapLayout({...plotMapLayout,
            mapbox: {...plotMapLayout.mapbox,
                        center:{
                        lat:airportData['location'][0],
                        lon:airportData['location'][1]
                        },
                        bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                             'east':airportData['location'][1]+200*NM_TO_DEG,
                            'south':airportData['location'][0]-200*NM_TO_DEG,
                             'west':airportData['location'][1]-200*NM_TO_DEG},
            zoom:7}});
    }
    const handleClickOnChart=(data)=>{
        console.log(data)
        var point = data.points[0]
        setLatestEpochFlag(false)
        if(!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))){
            return;
        }
        console.log(point)
        console.log(point.pointIndex)
        console.log(epochString[point.pointIndex])
        setSelectedEpoch(epochString[point.pointIndex])
        updateMapData(epochString[point.pointIndex])
    };
    function updateMapData(epoch){
        var metricApi = backendApiPrefix+'/api/get-flight-plan-change-events/'
        setIsMapLoading(true)
        axios.post(metricApi,{airport:airport,epoch:epoch})
          .then(response =>{
              var jsonData = response.data.message
              console.log(jsonData)
              setMapData(jsonData)
              setIsMapLoading(false)
          }).catch(error => {
            console.log(error);
            setIsMapLoading(false)
          });
    };

    var highlightMarkerTrace = { x:[selectedEpoch,selectedEpoch],
        y:[0,highlightYMarker['index']],
        type:'scatter',
        xaxis:'x',yaxis:'y',
        mode:'lines',
        showlegend:false,
        hoverinfo:'skip',
        line:{color:'black',dash:'dashdot'}}

    const handleClickOnCheckbox=(e,lvl)=>{
        console.log(lvl,countLevelChecked);
        setCountLevelChecked({
            ...countLevelChecked,
            [lvl]:!countLevelChecked[lvl]
        })
    };
    const handleMapTimeRangeChange=(event,newValue)=>{
        if(newValue){
          setMapTimeRange(newValue)
        }
        
      };
    useEffect(()=>{
        var traceData = {type: "scattermapbox", lon:mapData[mapTimeRange]['lon'], 
                                  lat:mapData[mapTimeRange]['lat'], 
                                  text:mapData[mapTimeRange]['alt'],
                                  customdata:mapData[mapTimeRange]['additionalData'],
                          name:'flightPlanChangeEvents',
                          radius: 50,
                          hovertemplate:'<extra></extra>%{customdata[0]}<br>Lat:%{lat}, Lon:%{lon}, Alt:%{text}ft'}
        
        traceData['marker'] = {color:'rgba(28, 167, 28,0.6)',size:15}
        traceData['hovertemplate'] = traceData['hovertemplate']+'<br>Old FlightPlan:%{customdata[1]},<br>New FlightPlan:%{customdata[2]}'
        setMapPlotTraces([traceData])
      },[mapData,mapTimeRange])
    var flightPlanChangeTrace = []
    for(var lvl of countLevels){
        if(!countLevelChecked[lvl]){
            continue;
        }
        flightPlanChangeTrace.push({
            x: flightPlanChangeCounts.epochString,
            y: flightPlanChangeCounts[lvl+'min'],
            type: 'scatter',
            mode: 'lines',
            // marker: {color: colorPalette[12]},
            hovertemplate:'%{y}<extra>'+countLevelLabels[lvl+'min']+'</extra>',
            name:countLevelLabels[lvl+'min'],
            xaxis:'x',
            yaxis:'y',
          })    
    }    
    return (
        <Layout>
        <PlotSectionDiv id="chartPlotDiv" flexRatio={5}>
            <PlotLoadingOverlay show={isChartLoading}/>
            <EpochDataBlock selectedEpoch={selectedEpoch} handleLatestEpochButton={handleLatestEpochButton}
                            lastUpdatedTime={lastUpdatedTime}/>
            <Plot  data={[...flightPlanChangeTrace,highlightMarkerTrace]}
                layout= {plotChartLayout}
                config= {plotConfig}
                divId={'plotlyChartDiv'}
                style={{minWidth:'300px',height:'45%',position:'relative'}}
                useResizeHandler={true}
                onClick={handleClickOnChart}
                onDoubleClick={()=>{}}
              />
            <div style={{textAlign:'left',marginLeft:'70px',marginRight:'105px',marginTop:'15px',display:'flex',flex:'1 1 auto',flexWrap:'wrap',justifyContent:'flex-start'}}>
                {countLevels.map((lvl)=>{
                        return( <div style={{width:'120px',color:'#275AA6'}}>
                                    <Checkbox  checked={countLevelChecked[lvl]} 
                                               onChange={(e)=>{handleClickOnCheckbox(e,lvl)}
                                                        }
                                    />
                                    {countLevelLabels[lvl+'min']}
                                </div>)})}
            </div>
        </PlotSectionDiv>
        <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={3}>
            <PlotLoadingOverlay show={isMapLoading} label="Loading map…"/>
            <Box sx={{mb:1,mt:1,ml:0,mr:0}}>
              <ToggleButtonGroup fullWidth
                  color="primary"
                  value={mapTimeRange}
                  exclusive
                  onChange={handleMapTimeRangeChange}
                  aria-label="Platform"
                  sx={{height:30}}
                >
                  <ToggleButton value="5min">5 Minutes</ToggleButton>
                  <ToggleButton value="1hr">1 Hour</ToggleButton>
                  <ToggleButton value="24hr">24 Hours</ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <Plot data={[airportMapTrace,...mapPlotTraces]}
                  layout= {plotMapLayout}
                  config= {{...plotConfig,scrollZoom:true}}
                  useResizeHandler={true}
                  divId={'plotlyMapDiv'}
                  style={{minWidth:'300px',height:'90%',position:'relative',borderWidth:'2px',color:'yellow',
                            borderSyle:'solid',
                            borderColor:'black'}}
                  onDoubleClick={handleDoubleClickOnMap}
            />
        </PlotSectionDiv>  
        </Layout>
    );
};

export default FlightPlanChangeCounts


